import React from 'react';

const CheckLabel = ({ label, checked, onChange }) => {
  return (
    <label style={styles.label}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        style={styles.checkbox}
      />
      {label}
    </label>
  );
};

const styles = {
  label: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '13px',
    fontWeight: '500',
    cursor: 'pointer',
    color: '#3a4a5a',
    gap: '8px',
  },
  checkbox: {
    width: '15px',
    height: '15px',
    accentColor: '#3182F6',
    flexShrink: 0,
  },
};

export default CheckLabel;
